import amenitiesRu from "./internationalAmenities.ru";

/**
 * Returns the translated amenity array for an international listing.
 * Falls back to the original English array when no translation exists for
 * the requested language or slug.
 *
 * Silent data-drift guard: in development mode a console warning is emitted
 * when the translated array has a different length than the source array,
 * indicating a missing or extra translation entry.
 *
 * @param {{ slug: string, amenities?: string[] }} listing - Listing object.
 * @param {string} lang - i18next language code ("en" | "ru").
 * @returns {string[]} Translated (or original) amenity list.
 */
export function getIntlAmenities(listing, lang) {
  if (!listing.amenities?.length) return [];

  if (lang === "ru") {
    const translated = amenitiesRu[listing.slug];

    if (!translated) return listing.amenities; // no RU entry — fallback

    if (process.env.NODE_ENV === "development" && translated.length !== listing.amenities.length) {
      console.warn(
        `[getIntlAmenities] "${listing.slug}": RU has ${translated.length} amenities ` +
        `but EN has ${listing.amenities.length}. Keep arrays in sync.`
      );
    }

    return translated;
  }

  return listing.amenities;
}
